import Plurix from "../../../../assets/images/LogoFooterPlurix.png";
import "./PlurixFooter.scss";

const PlurixFooter = () => {
  return (
    <>
      <div className="plurix-banner-footer">
        <img src={Plurix} alt="Plurix" />
      </div>
      <div className="plurix-content-info-footer ">
        <div className="plurix-social-networks">
          <p>Sac: 0800-3223200</p>
          <p>E-mail: contato@clubemaisamigo.com.br</p>
        </div>
        <div className="plurix-social-networks plurix-center-info">
          <a
            href="https://www.clubemaisamigo.com.br/_files/ugd/cddd7a_e32b5ccd2bc14597ba8fa4fe419a72cc.pdf"
            target="_blank"
          >
            Política de Privacidade
          </a>
        </div>
      </div>
    </>
  );
};

export default PlurixFooter;
